import { vipAxios, Response } from './index';
import { mgmtAxios, MgmtEnvelope, getMgmtMemberToken } from './mgmt';
// import { AxiosError } from 'axios';

// PG-56/180 我的租借/歸還紀錄:新後端 MemberRentalLog → n18 既有 Logs1Type
interface MgmtRental {
  id: number;
  packaging_id: string;
  rented_at: string | null;
  returned_at: string | null;
  return_type: string | null;
  return_location_id: string | null;
  renter_id: number | null;
  return_user_id: number | null;
  packaging?: { id: string } | null;
  returnLocation?: { name: string } | null;
  renter?: { realname: string | null; nickname: string | null; mobile_number: string | null } | null;
  returnUser?: { realname: string | null; nickname: string | null; mobile_number: string | null } | null;
  // PG-209 全家寄件單(後端 Eloquent 關聯序列化是 snake_case,保險兩種都收)
  fme_returnship_order?: MgmtFmeOrder | null;
  fmeReturnshipOrder?: MgmtFmeOrder | null;
}
export interface MgmtFmeOrder {
  order_no: string | null;
  flow_status: string | null;
  flow_label: 'pending' | 'consigned' | 'expired' | 'failed';
  expires_at: string | null;
  created_at: string | null;
}
const personName = (p?: { realname: string | null; nickname: string | null } | null) =>
  p ? (p.realname || p.nickname || '') : '';
const mapMgmtRental = (r: MgmtRental): any => ({
  id: r.id,
  fme_order: r.fme_returnship_order ?? r.fmeReturnshipOrder ?? null,
  created_at: r.rented_at ?? '',
  shipping_at: r.returned_at ?? '',
  expired_at: '',
  overdue_at: '',
  svpt_id: 0,
  svpt_name: r.returnLocation?.name ?? '',
  renter_id: r.renter_id ?? 0,
  renter_name: personName(r.renter),
  renter_mobile: r.renter?.mobile_number ?? '',
  return_user_id: r.return_user_id ?? 0,
  return_name: personName(r.returnUser),
  mobile_number: r.returnUser?.mobile_number ?? '',
  chs_id: 0,
  channel_name: '',
  rent_type: 0,
  rentTypeName: '',
  paid_amount: 0,
  paid_way: 0,
  paidWayName: '',
  eco_id: 0,
  eco_short_code: r.packaging_id,
  ec_partner_id: 0,
  ec_partner_name: '',
  count_return: 0,
  count_using: 0,
  count_expired: 0,
  epk_id: r.packaging_id ?? r.packaging?.id ?? '',
});
interface MgmtPaginated<T> { data: T[]; pagination: { total: number } }
const fetchMgmtRentals = async (path: string): Promise<MgmtRental[]> => {
  const token = getMgmtMemberToken();
  const { data } = await mgmtAxios.request<MgmtEnvelope<MgmtPaginated<MgmtRental>>>({
    url: path,
    method: 'GET',
    params: { per_page: 200 },
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  return data.details?.data ?? [];
};
const fetchMgmtTotal = async (path: string): Promise<number> => {
  const token = getMgmtMemberToken();
  const { data } = await mgmtAxios.request<MgmtEnvelope<MgmtPaginated<MgmtRental>>>({
    url: path,
    method: 'GET',
    params: { per_page: 1 },
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  return data.details?.pagination?.total ?? 0;
};

export interface Logs1CountType {
  count4return: number;
}
export interface Logs2CountType {
  count4all: number;
  count4using: number;
  count4expired: number;
  count4return: number;
}
export interface Logs1Type {
  id: number;
  created_at: string;
  shipping_at: string; // 23.01.05 SCH
  expired_at: string;
  overdue_at: string; // 23.01.05 SCH
  svpt_id: number;
  svpt_name: string;
  renter_id: number;
  renter_name: string;
  renter_mobile: string;
  return_user_id: number;
  return_name: string;
  mobile_number: string;
  chs_id: number;
  channel_name: string; // 21.12.15 SCH
  rent_type: number;
  rentTypeName: string; // 22.04.22 SCH
  paid_amount: number; // 22.04.22 SCH
  paid_way: number;
  paidWayName: string; // 22.04.22 SCH
  eco_id: number;
  eco_short_code: string; // 22.04.22 SCH
  ec_partner_id: number;
  ec_partner_name: string; // 22.04.22 SCH
  count_return: number;
  count_using: number;
  count_expired: number;
  epk_id: string;
  /** PG-209 全家寄件單,非全家歸還為 null */
  fme_order?: MgmtFmeOrder | null;
}
/**
 * 取得歸還記錄!!
 */
export const listUserRentLogs = async (
  token: string,
  brandID: number,
  userID: number,
  filterSelf: number,
  sort: string, // 22.05.30 SCH
): Promise<Response<Logs1Type[]>> => {
    // PG-56/180 改讀新後端「歸還紀錄」(status=returned)
    const rows = await fetchMgmtRentals('/api/member/rentals/history');
    return { data: rows.map(mapMgmtRental) };
};

/**
 * 取得租借記錄!! // 22.04.22 SCH
 */
// 會員中心「使用中 / 逾期」:寄到我手機、還沒歸還的出貨(對齊舊站 listRentDataLogs 的資料來源)。
// 外循環的租借不是掃碼建立的,而是電商出貨,所以不能拿 /rentals(active 租借)當「使用中」—— 那永遠是空的。
interface MgmtShipment {
  id: number;
  source: 'online' | 'offline';
  order_no: string | null;
  packaging_code: string | null;
  ec_channel_name: string | null;
  shipped_at: string | null;
  expired_at: string | null;
  is_overdue: boolean;
  days_left: number | null;
}
const mapMgmtShipment = (s: MgmtShipment): Logs1Type => ({
  id: s.id,
  created_at: s.shipped_at ?? '',
  shipping_at: s.shipped_at ?? '',
  expired_at: s.expired_at ?? '',
  overdue_at: s.is_overdue ? (s.expired_at ?? '') : '',
  svpt_id: 0,
  svpt_name: '',
  renter_id: 0,
  renter_name: '',
  renter_mobile: '',
  return_user_id: 0,
  return_name: '',
  mobile_number: '',
  chs_id: 0,
  channel_name: '',
  rent_type: s.source === 'online' ? 3 : 0,
  rentTypeName: s.source === 'online' ? '電商訂單' : '人工匯入',
  paid_amount: 0,
  paid_way: 0,
  paidWayName: '',
  eco_id: 0,
  eco_short_code: s.order_no ?? '',
  ec_partner_id: 0,
  ec_partner_name: s.ec_channel_name ?? '',
  count_return: 0,
  count_using: 0,
  count_expired: 0,
  epk_id: s.packaging_code ?? '',
});
const fetchMgmtShipments = async (filter: 'all' | 'using' | 'expired'): Promise<MgmtShipment[]> => {
  const token = getMgmtMemberToken();
  const { data } = await mgmtAxios.request<MgmtEnvelope<MgmtShipment[]>>({
    url: '/api/member/shipments',
    method: 'GET',
    params: { filter },
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  return data.details ?? [];
};
const fetchMgmtShipmentSummary = async (): Promise<{ using: number; expired: number; total: number }> => {
  const token = getMgmtMemberToken();
  const { data } = await mgmtAxios.request<MgmtEnvelope<{ using: number; expired: number; total: number }>>({
    url: '/api/member/shipments/summary',
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  return data.details ?? { using: 0, expired: 0, total: 0 };
};

export const listRentDataLogs = async (
    token: string,
    brandID: number,
    userID: number,
    filter: string,
    sort: string, // 22.05.30 SCH
): Promise<Response<Logs1Type[]>> => {
    if (filter === 'return') {
      const rows = await fetchMgmtRentals('/api/member/rentals/history');
      return { data: rows.map(mapMgmtRental) };
    }
    const f = filter === 'using' || filter === 'expired' ? filter : 'all';
    const rows = await fetchMgmtShipments(f);
    return { data: rows.map(mapMgmtShipment) };
};
export const countRentDataLogs = async (
    token: string,
    brandID: number,
    userID: number,
    filter: string
): Promise<Response<Logs2CountType>> => {
    const summary = await fetchMgmtShipmentSummary();
    const returned = await fetchMgmtTotal('/api/member/rentals/history');
    return {
      data: {
        count4all: summary.total + returned,
        count4using: summary.using,
        count4expired: summary.expired,
        count4return: returned,
      },
    };
};

// PG-178 我的券:新後端 coupons/claimed
interface MgmtClaimedCoupon {
  id: number;
  title: string | null;
  image_url: string | null;
  use_type: number;
  use_type_label: string | null;
  promotion_code: string | null;
  redeem_url: string | null;
  use_end_at: string | null;
  claimed_at: string;
}
const fetchClaimedCoupons = async (): Promise<MgmtClaimedCoupon[]> => {
  const token = getMgmtMemberToken();
  const { data } = await mgmtAxios.request<MgmtEnvelope<MgmtClaimedCoupon[]>>({
    url: '/api/member/coupons/claimed',
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  return data.details || [];
};

export interface UserCouponsData {
  id: number;
  coupon_id: number;
  title: string;
  description: string;
  start_at: string;
  expired_at: string;
  created_at: string;
  picture_url: string; // 22.05.29 SCH
}
/**
 * 取得(線上)電商優惠券(Coupons)!!
 */
export const listUserCoupons = async (
  token: string,
  brandID: number,
  userID: number,
  filter: string, 
  sort: string, 
): Promise<Response<UserCouponsData[]>> => {
    // PG-178 改讀新後端「我的券」
    const rows = await fetchClaimedCoupons();
    return {
      data: rows.map((c) => ({
        id: c.id,
        coupon_id: c.id,
        title: c.title ?? '',
        description: c.use_type_label ?? '',
        start_at: '',
        expired_at: c.use_end_at ?? '',
        created_at: c.claimed_at ?? '',
        picture_url: c.image_url ?? '',
      })),
    };
};

export interface UserVoucherLogsData {
  id: number;
  userVoucherLog_id: number;
  user_rent_log_id: number;
  return_user_id: number;
  chs_id: number;
  svpt_id: number;
  svpt_info: string;
  created_at: string;
  use_type: number; // 21.12.22 SCH
  redeem_code: string;
  giftcard_code: string;
  redeem_url: string;
  pin_code: string;
  used: boolean; // 21.12.29 SCH
  picture_url: string; // 22.05.29 SCH
  picture_url_small: string; // 22.05.29 SCH
  expired_at: string;
  start_at: string;
  start_use_at: string;
  expired_use_at: string;
}
/**
 * 取得歸還者兌換券
 */
export const listUserVoucherLogs = async (
  token: string,
  brandID: number,
  userID: number,
  filter: string, 
  sort: string, 
): Promise<Response<UserVoucherLogsData[]>> => {
    // PG-178 改讀新後端「我的券」(帶優惠碼/兌換連結)
    const rows = await fetchClaimedCoupons();
    return {
      data: rows.map((c) => ({
        id: c.id,
        userVoucherLog_id: c.id,
        user_rent_log_id: 0,
        return_user_id: 0,
        chs_id: 0,
        svpt_id: 0,
        svpt_info: c.title ?? '',
        created_at: c.claimed_at ?? '',
        use_type: c.use_type,
        redeem_code: c.promotion_code ?? '',
        giftcard_code: '',
        redeem_url: c.redeem_url ?? '',
        pin_code: '',
        used: false,
        picture_url: c.image_url ?? '',
        picture_url_small: c.image_url ?? '',
        expired_at: c.use_end_at ?? '',
        start_at: '',
        start_use_at: '',
        expired_use_at: c.use_end_at ?? '',
      })),
    };
};

interface StoreRes<Data> {
  error?: any;
  data: Data;
  meta?: {
    current_page: number;
    per_page: number;
    total: number;
  };
}

export interface Product {
  id: number;
  brand_name: string;
  name: string;
  recommend: 0 | 1;
  hot: 0 | 1;
  price: number;
  discount: number | null;
  images: { id: number; url: string }[];
  available_quantity: number;
  inventory_quantity: number;
  maximum_quantity: number;
  description: string;
  note: string;
  shops: { id: number; name: string }[];
  shop_groups: { id: number; name: string }[];
  package: {
    package_unit_price: number;
    product_id: number;
    product_name: string;
    product_quantity: number;
  }[];
  type_deduct: 1 | 2 | 3;
  period_discount: 1 | 2;
  discount_start_date: string;
  discount_end_date: string;
  period_sales: 1 | 2;
  sales_start_date: string;
  sales_end_date: string;
}

export interface Category {
  id: number;
  name: string;
}
/**
 * 獲取分類列表
 * @param token token
 */
export const getCategories = async (
  token: string
): Promise<Response<Category[]>> => {
  try {
    const { data } = await vipAxios.request<StoreRes<Category[]>>({
      url: `/api/member/category`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return { data: data.data };
  } catch (error: any) {
    console.log(error);
    return { error, data: undefined };
  }
};

export interface PaymentInfo {
  name: string | null;
  phone: string | null;
  email: string | null;
  location: string | null;
  order_cost: number;
  zip_code: string | null;
  address: string | null;
  carrier_option: 'phone' | 'company' | 'member' | null;
  carrier_value: string | null;
  gui_title: string | null;
  gui_number: string | null;
}
/**
 * 取得 付款資訊
 * @param token
 * @param orderID 訂單ID
 * @apinums 590
 * @returns
 */
export const getPaymenyInfo = async (
  token: string
): Promise<Response<PaymentInfo>> => {
  try {
    const { data } = await vipAxios.request<StoreRes<PaymentInfo>>({
      url: `/api/member/payment`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return { data: data.data };
  } catch (error: any) {
    console.log(error);
    return { error, data: undefined };
  }
};
